// ============================================================
// Mock Data
// ============================================================
// Simulated backend data for development. Every entity
// references a schoolId for multi-school context.

import { ROLES } from '@/constants/roles';

// ── Mock Schools ──────────────────────────────────────────
export const mockSchools = [
  {
    id: 'school-001',
    name: 'Springfield Academy',
    code: 'SPA',
    address: '123 Education Lane, Springfield',
    phone: '+1 (555) 100-2001',
    email: 'admin@springfield.edu',
    logo: null,
    principalName: 'Dr. Sarah Johnson',
    studentCount: 1250,
    teacherCount: 85,
    status: 'active',
    createdAt: '2024-01-15',
  },
  {
    id: 'school-002',
    name: 'Riverside International School',
    code: 'RIS',
    address: '456 River Road, Riverside',
    phone: '+1 (555) 200-3002',
    email: 'admin@riverside.edu',
    logo: null,
    principalName: 'Prof. Michael Chen',
    studentCount: 980,
    teacherCount: 62,
    status: 'active',
    createdAt: '2024-03-20',
  },
  {
    id: 'school-003',
    name: 'Hilltop Grammar School',
    code: 'HGS',
    address: '789 Hilltop Avenue, Hilltown',
    phone: '+1 (555) 300-4003',
    email: 'admin@hilltop.edu',
    logo: null,
    principalName: 'Mrs. Emily Davis',
    studentCount: 670,
    teacherCount: 45,
    status: 'active',
    createdAt: '2024-06-10',
  },
];

// ── Mock Users (one per role) ─────────────────────────────
export const mockUsers = {
  owner: {
    id: 'user-001',
    name: 'Admin Owner',
    email: 'owner@springfield.edu',
    role: ROLES.ORGANIZATION_ADMIN,
    avatar: null,
    phone: '+1 (555) 000-0001',
    schoolId: null, // Owner has access to all schools
    schools: mockSchools.map((s) => s.id),
    status: 'active',
  },
  principal: {
    id: 'user-002',
    name: 'Dr. Sarah Johnson',
    email: 'principal@springfield.edu',
    role: ROLES.PRINCIPAL,
    avatar: null,
    phone: '+1 (555) 000-0002',
    schoolId: 'school-001',
    schools: ['school-001'],
    status: 'active',
  },
  reception: {
    id: 'user-003',
    name: 'Lisa Martinez',
    email: 'reception@springfield.edu',
    role: ROLES.RECEPTION,
    avatar: null,
    phone: '+1 (555) 000-0003',
    schoolId: 'school-001',
    schools: ['school-001'],
    status: 'active',
  },
  accountant: {
    id: 'user-004',
    name: 'James Wilson',
    email: 'accountant@springfield.edu',
    role: ROLES.ACCOUNTANT,
    avatar: null,
    phone: '+1 (555) 000-0004',
    schoolId: 'school-001',
    schools: ['school-001'],
    status: 'active',
  },
};


// ── Mock Notifications ───────────────────────────────────
export const mockNotifications = [
  {
    id: 'notif-1',
    title: 'New Admission Request',
    message: 'A new admission request has been submitted for Grade 5.',
    type: 'info',
    read: false,
    time: '10 minutes ago',
    schoolId: 'school-001',
  },
  {
    id: 'notif-2',
    title: 'Fee Payment Overdue',
    message: '15 students have overdue fee payments this month.',
    type: 'warning',
    read: false,
    time: '1 hour ago',
    schoolId: 'school-001',
  },
  {
    id: 'notif-3',
    title: 'Exam Results Published',
    message: 'Mid-term exam results for Grade 10 have been published.',
    type: 'success',
    read: true,
    time: '3 hours ago',
    schoolId: 'school-001',
  },
  {
    id: 'notif-4',
    title: 'System Maintenance',
    message: 'Scheduled maintenance window tonight at 2:00 AM.',
    type: 'info',
    read: true,
    time: '1 day ago',
    schoolId: null,
  },
];
